import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import { CircularProgress, Typography } from "@mui/material";
import { useQuery} from "@apollo/client";
import { setupManagementUrl } from "../../../config";
import Form from "./forms";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import { useNavigate } from "react-router-dom";
import Joyride from "react-joyride"; // Import Joyride

const base_url = setupManagementUrl.uri;
// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Product Charges Accounts View page, where you can view Product Charges Accounts.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Product Charges Accounts by name or other criteria.",
    placement: "bottom",
  },
  // {
  //   target: ".dynamic-table-add-button",
  //   content: "Click this button to add a new business type.",
  //   placement: "right",
  // },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  // {
  //   target: ".dynamic-table-actions",
  //   content: "Select actions to be able to Edit each business type from this dropdown.",
  //   placement: "left",
  // },
];
const ProductChargesAccountsTable = ({Id}) => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const productId= localStorage.getItem("ProductId")

  const navigate = useNavigate();

  
  const actions = {
    entity:localStorage.getItem("SelectedRight"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
      modelName: "productchargesaccountIds",
      inputObjectName: "bulkActivateDeactivateProductChargesAccounts",
    },
    dataObject: {
     objectName: "productChargesAccountsByProductId",
    parameters: {productId: parseInt(productId)},
    inputObjectName:"productChargesAccount",
    },
    showMore:{
      search:false,
      min: 0,
      max:0
    }
  };
  
  return (
    <Box m="20px">
         <Joyride
              steps={rightsTourSteps}
              run={runTour}
              continuous
              showSkipButton
              showProgress
              styles={{
                options: {
                  primaryColor: "#1976d2",
                  zIndex: 10000,
                },
              }}
            />
                    {/* Top Bar */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
                Start Page Tour
              </Button>
       <Button onClick={ () => navigate(-1)} variant="contained">
            Back to Products
          </Button>
      </Box>
      <>
      </>
      <DynamicTableForJson
        title="ProductChargesAccountsView"
        subtitle="Manage ProductChargesAccounts"
        //columns={RightsColumns}
        FormComponent={Form}
        //query={allRights}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
        />
    </Box>
  );
};

export default ProductChargesAccountsTable;
